import axios from "axios";
import {getCookie} from "@/lib/cookie";


/**
 *
 * @param reqobj
 * @returns {Promise<unknown>}
 */
function confermaInserimento(reqobj) {

    return new Promise((resolve, reject) => {

        let cookie = getCookie('XSRF-TOKEN');

        axios.post(process.env.VUE_APP_API_BASE_URL + process.env.VUE_APP_URL_INSERIMENTOTICKET,
            reqobj,{headers:{'X-CSRF-TOKEN':cookie}}).then(response => {
            resolve(response)
        }).catch(err => {
            reject(err)
        });
    });
}

/**
 * usata solo per i ticket con corrispondenza  con un ticket chiuso ok.
 * @param context
 * @returns {Promise<unknown>}
 */
function  confermaInserimentoTicketOK(context){

    return new Promise((resolve, reject) => {
        let cookie = getCookie('XSRF-TOKEN');
        axios.post(document.querySelector('meta[name="server_source"]').content + process.env.VUE_APP_URL_INSERIMENTOTICKETVELOCE,
            {
                compagnia: context.state.volo.compagnia,
                datavolo: context.getters["volo/getDataVoloFormattataISO"],
                numerovolo: context.getters["volo/getCodiceCompagniaSelezionata"] + context.state.volo.numerovolo,
                nome: context.state.passeggero.nome,
                cognome: context.state.passeggero.cognome,
                email: context.state.passeggero.email,
                telefono: context.state.passeggero.telefono,
                disservizio: context.state.volo.tipoproblema,
                informazioni: '',
                recaptcha_token: context.state.recaptcha_token,
                partenza: context.state.volo.partenza.id,
                destinazione: context.state.volo.destinazione.id,
                firma: context.state.passeggero.firma,
                iban: context.state.passeggero.iban,
                cmptk: context.state.tokencampagna,
                utm_source: context.state.utm_source,
                utm_medium : context.state.utm_medium,
                utm_campaign : context.state.utm_campaign,
                coincidenze: JSON.stringify(context.state.volo.coincidenze),
                prtncode: context.state.partner_code
            },{headers:{'X-CSRF-TOKEN':cookie}}).then(response => {
            resolve(response)
        }).catch(err => {
            reject(err)
        });
    });
}

/**
 *
 * @param datacomunicazione
 * @param ticketref
 * @returns {Promise<unknown>}
 */
function submitDataComunicazione(datacomunicazione,ticketref){
    return new Promise((resolve, reject) => {

        let cookie = getCookie('XSRF-TOKEN');

        axios.post(process.env.VUE_APP_API_BASE_URL + process.env.VUE_APP_URL_COMUNICAZIONE_COMPAGNIA,
            {"data":datacomunicazione, "ticketref":ticketref},{headers:{'X-CSRF-TOKEN':cookie}}).then(response => {
            resolve(response)
        }).catch(err => {
            reject(err)
        });
    });
}

/**
 *
 * @param riprotezione
 * @param datariprotezione
 * @param bagaglioriconsegnato
 * @param datariconsegnabagaglio
 * @param ticketref
 * @returns {Promise<unknown>}
 */
function submitRiprotezioneBagaglio(riprotezione,datariprotezione,bagaglioriconsegnato,datariconsegnabagaglio,ticketref,acquisti){
    return new Promise((resolve, reject) => {

        let cookie = getCookie('XSRF-TOKEN');
        let reqobj = {
            ticketref:ticketref,
            riprotezione: riprotezione,
            datariprotezione: datariprotezione,
            bagaglioriconsegnato: bagaglioriconsegnato,
            datariconsegnabagaglio: datariconsegnabagaglio,
            acquisti: acquisti
        }
        axios.post(process.env.VUE_APP_API_BASE_URL + process.env.VUE_APP_URL_RIPROTEZIONE_BAGAGLIO,
            reqobj,{headers:{'X-CSRF-TOKEN':cookie}}).then(response => {
            resolve(response)
        }).catch(err => {
            reject(err)
        });
    });
}

/**
 *
 * @param ticketref
 * @returns {Promise<unknown>}
 */
function submitConclusioneProcesso(ticketref){
    return new Promise( (resolve,reject)=>{
        let cookie = getCookie('XSRF-TOKEN');
        let reqobj = {
            ticketref: ticketref,
        }
        axios.post(process.env.VUE_APP_API_BASE_URL + process.env.VUE_APP_URL_CONCLUSIONEPROCESSO,
            reqobj,{headers:{'X-CSRF-TOKEN':cookie}}).then(response => {
            resolve(response)
        }).catch(err => {
            reject(err)
        });
    });
}

function submitConclusioneInserimentoTicket(ticketref){
    return new Promise( (resolve,reject)=>{
        let cookie = getCookie('XSRF-TOKEN');
        let reqobj = {
            ticketref: ticketref,
        }
        axios.post(process.env.VUE_APP_API_BASE_URL + process.env.VUE_APP_URL_CONCLUSIONEINSERIMENTOTICKET,
            reqobj,{headers:{'X-CSRF-TOKEN':cookie}}).then(response => {
            resolve(response)
        }).catch(err => {
            reject(err)
        });
    });
}

function submitDescrizioneAcquisti(ticketref,descrizione){
    return new Promise( (resolve,reject)=>{
        let cookie = getCookie('XSRF-TOKEN');
        let reqobj = {
            ticketref: ticketref,
            descrizione: descrizione,
        }
        axios.post(process.env.VUE_APP_API_BASE_URL + process.env.VUE_APP_URL_DESCRIZIONEACQUISTI,
            reqobj,{headers:{'X-CSRF-TOKEN':cookie}}).then(response => {
            resolve(response)
        }).catch(err => {
            reject(err)
        });
    });
}

function submitFirmaMandato(ticketref){
    return new Promise( (resolve,reject)=>{
        let cookie = getCookie('XSRF-TOKEN');
        let reqobj = {
            ticketref: ticketref,
        }
        axios.post(process.env.VUE_APP_API_BASE_URL + process.env.VUE_APP_URL_FIRMAMANDATO,
            reqobj,{headers:{'X-CSRF-TOKEN':cookie}}).then(response => {
            resolve(response)
        }).catch(err => {
            reject(err)
        });
    });
}

export {
    confermaInserimento ,
    submitDataComunicazione,
    confermaInserimentoTicketOK,
    submitRiprotezioneBagaglio,
    submitConclusioneProcesso,
    submitConclusioneInserimentoTicket,
    submitDescrizioneAcquisti,
    submitFirmaMandato
}